import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { closedPageMessage, limitedHomePath, type LimitedAccess, type PageArea } from '@/lib/limitedAccess';

/**
 * Shown in place of a screen a limited person can't use (lib/limitedAccess.ts). The gateway
 * refuses those changes anyway; this says why before anyone tries.
 */
export function ClosedPage({ access, area }: { access: LimitedAccess; area: PageArea }) {
  const { title, body } = closedPageMessage(access, area);
  return (
    <div className="mx-auto max-w-lg p-6" data-closed-page>
      <div className="rounded-xl border border-brand-border bg-white p-6 text-center">
        <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-brand-lilac">
          <Lock className="h-5 w-5 text-brand-plum" />
        </div>
        <h1 className="font-heading text-lg font-semibold text-brand-midnight">{title}</h1>
        <p className="mt-2 text-sm text-brand-ink-soft">{body}</p>
        <div className="mt-5 flex flex-wrap justify-center gap-2">
          {access.managed && area !== 'billing' && access.areas.includes('requests') && (
            <Button asChild className="bg-brand-plum text-white hover:bg-brand-plum-deep" data-closed-request>
              <Link to="/requests">Request a change</Link>
            </Button>
          )}
          <Button asChild variant={access.managed && access.areas.includes('requests') ? 'outline' : 'default'} className={access.managed && access.areas.includes('requests') ? '' : 'bg-brand-plum text-white hover:bg-brand-plum-deep'}>
            <Link to={limitedHomePath(access)}>Back to my dashboard</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
